import { createReduxStore } from "src/store/redux_store";

const initialState = {
  data: {
    email: "",
    firstName: "",
    org: null,
    userId: null,
    cookieBannerIsShowing: false,
    tokenUUID: null,
    // set messaging for password step
    contextualMessage: null,
    successMessage: null,
  },
  loading: false,
  error: null,
};

const LoginStore = createReduxStore({
  name: "login",
  initialState,
  reducers: {
    clearError: (state) => ({ ...state, error: null }),
  },
});

export { LoginStore };
